import { observer } from "mobx-react";
import React, { useContext, useEffect } from "react";
import { useStores } from "../../../../../hooks";
import { Helmet } from "react-helmet";
import { Box, Grid } from "@material-ui/core";
import { BackButton, Divider, Space, Typography } from "../../../../../common/components/libs";
import { FadeInOutVertical } from "../../../../../common/components/Animated";
import NoOrders from "../../../../stats/pages/ordersData/components/NoOrders";
import { Centered } from "../../../../../common/components/libs";
import { useParams } from "react-router-dom";
import OrdersTable from "./table/OrdersTable";
import OrderCard from "./card/OrderCard";
import FilterForCard from "./card/FilterForCard";
import ClientOrdersStoreContext from "../store/context";
import FilterForTable from "./table/FilterForTable";
import ChooseMenu from "./ChooseMenu";
import {Trans, useTranslation} from "react-i18next";


const OrdersList = () => {
    const { generalStore } = useStores();
    const ordersStore = useContext(ClientOrdersStoreContext);
    const { ordersList } = ordersStore;
    const {i18n, t, ready} = useTranslation(["orders"], { useSuspense: false });
    const locale = i18n.language;

    const filter = ordersStore.filter;
    let { clientId } = useParams();

    useEffect(() => {
        ordersStore.init();
        generalStore.setPageTitle(t("orders:title"));
    }, [ready]);

    useEffect(() => {
        clientId = Number(clientId);
        let clientsIdsArr = [];
        clientsIdsArr.push(clientId);
        ordersStore.getOrders({
            ...filter,
            clientsIds: clientsIdsArr
        });
    }, [ordersStore.filter]);


    if (!ordersList) return null;

    const orders = ordersList.slice().reverse();


    return <>
        <Helmet title={t("orders:title")}/>
        <BackButton/>
        <Grid justify="space-between" alignItems='center' container spacing={8}>
            <Grid item>
                <Typography variant="h3" ml={2}>
                    <Trans i18nKey="orders:infoTitle" values={{clientId: clientId}}/>
                </Typography>
            </Grid>
            <Grid item>
                <ChooseMenu/>
            </Grid>
        </Grid>
        <Divider my={6}/>
        <Grid container spacing={6}>
            <Grid item xs={12} style={{ marginBottom: "150px" }}>
                <FadeInOutVertical show={true}>
                    <div>
                        <Box display={{ xs: "none", sm: "block", md: "block", lg: "block", xl: "block" }}>
                            <FilterForTable/>
                        </Box>
                        <Box display={{ xs: "block", sm: "none", md: "none", lg: "none", xl: "none" }}>
                            <FilterForCard/>
                        </Box>
                        {orders.length === 0 &&
                        <Centered>
                          <NoOrders/>
                        </Centered>
                        }
                        {orders.length > 0 &&
                        <Box display={{ xs: "none", sm: "block", md: "block", lg: "block", xl: "block" }}>
                          <OrdersTable orders={orders}/>
                        </Box>
                        }
                        {orders.length > 0 &&
                        <Box display={{ xs: "block", sm: "none", md: "none", lg: "none", xl: "none" }}>
                            {orders.map((order) => {
                                return (
                                    <>
                                        <OrderCard order={order}/>
                                        <Space size={10}/>
                                    </>
                                );
                            })}
                        </Box>
                        }
                    </div>
                </FadeInOutVertical>
            </Grid>
        </Grid>


    </>;
};


export default observer(OrdersList);
